import useApiMutation from 'shared/hooks/use-api-mutation';

const useEditSavedFields = () => {
  return useApiMutation({
    method: 'PATCH',
    url: '/users/me',
    errorTitle: 'Erro ao salvar alterações na tabela',
  });
};

export default useEditSavedFields;
